import { render, staticRenderFns } from "./Agenda.vue?vue&type=template&id=507300e0"
import script from "./Agenda.vue?vue&type=script&setup=true&lang=ts"
export * from "./Agenda.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Agenda.vue?vue&type=style&index=0&id=507300e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports